const Version = {
    appVersion: '',
    appPlat: '',
    commitID: '',
}
Version['appVersion']='1.00.135'
Version['appPlat'] = 'todo'
Version['commitID']='6f4b71d2a'

export default Version